import buttonStyles from '../../../../components/Button/styles/Button.module.css'

/**
 * Links de navegação (para outra tela) com o mesmo visual do <Button variant='secondary-outline'>:
 * continuam sendo links (abrir em nova aba, leitor anuncia "link"), só o estilo é de botão.
 */
export const CLASSE_LINK_OUTLINE = `d-flex btn align-items-center justify-content-center btn-outline ${buttonStyles.secondaryOutline}`
